import React from 'react';
import { useIntl } from 'react-intl';
import translations from '../login/welcome.i18n';
import * as css from './index.module.scss';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const { formatMessage } = useIntl();
  const labels = {
    rightsAndPrivacy: formatMessage({ id: translations.rightsAndPrivacy.id }),
    cookies: formatMessage({ id: translations.aboutCookiesTitle.id }),
    analytics: formatMessage({ id: translations.aboutAnalyticsTitle.id }),
    accessibility: formatMessage({
      id: translations.accessibilityStatement.id,
    }),
  };

  return (
    <footer className={css.footer}>
      <nav>
        <Link className={css.link} to="/policy" data-cy={'policy-link'}>
          {labels.rightsAndPrivacy}
        </Link>
        <Link className={css.link} to="/cookies" data-cy={'cookies-link'}>
          {labels.cookies}
        </Link>
        <Link className={css.link} to="/analytics" data-cy={'analytics-link'}>
          {labels.analytics}
        </Link>
        <a
          className={css.link}
          href="https://uustatus.no/nb/erklaringer/publisert/8cc9ad7d-3bc0-4f9e-bbb1-95281870bf41"
        >
          {labels.accessibility}
        </a>
      </nav>
    </footer>
  );
};
